<template>
	<div class="navbar-box">
		<div class="navbar-content" v-if="setting.menu_list">
			<div @click="go(item.url)" class="navbar" :class="item.url == path ? 'active' : ''"
				v-for="(item, index) in setting.menu_list" :key="index">
				{{item.title}}
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'Navbar',
		props: {},
		watch: {
			$route(to) {
				this.path = to.path
			},
		},
		computed: {
			...mapState(["setting"]),
		},
		data() {
			return {
				path: '/'
				/*navbars: [{
						path: '/',
						title: '首页'
					},
					{
						path: '/category',
						title: '私人定制'
					},
					{
						path: '/categoryList',
						title: '精品定制'
					},
					{
						path: '/group_category',
						title: '团体定制'
					},
					{
						path: '/fashionShow',
						title: '服装展示'
					},
					{
						path: '/news',
						title: '新闻资讯'
					},
					{
						path: '/about',
						title: '联系我们'
					},
				]*/
			};
		},
		methods: {
			go(url) {
				if(!!url.includes('http')) {
					window.open(url)
					// location.href = url
				} else {
					this.$router.push(url)
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.navbar-box {
		width: 100%;
		height: 50px;
		background: #333333;
		box-shadow: 2px 1px 8px rgba(0, 0, 0, 0.19);

		.navbar-content {
			width: 1210px;
			height: 50px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			.navbar {
				font-size: 16px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #FFFFFF;
				padding: 0 50px;
				cursor: pointer;
				&.active {
					color: #EDD4AC;
				}
			}
		}



	}
</style>
